import { accountGrid } from '@/shared/grids/accountGrid';
import { checklistTemplateGrid } from '@/shared/grids/checklistTemplateGrid';
import { documentGrid } from '@/shared/grids/documentGrid';
import { formGrid } from '@/shared/grids/formGrid';
import { individualGrid } from '@/shared/grids/individualGrid';
import { memberGrid } from '@/shared/grids/memberGrid';
import { organisationGrid } from '@/shared/grids/organisationGrid';
import { recurringTaskGrid } from '@/shared/grids/recurringTaskGrid';
import { serviceGrid } from '@/shared/grids/serviceGrid';
import { smartTaskGrid } from '@/shared/grids/smartTaskGrid';
import { taskGrid } from '@/shared/grids/taskGrid';
import { templateGrid } from '@/shared/grids/templateGrid';
import { GridSettings } from '@/shared/types/grid';
import { ModelName } from '@/shared/types/model';

export const gridSettings: Partial<Record<ModelName, GridSettings<any>>> = {
  AccountView: accountGrid,
  OrganisationView: organisationGrid,
  ChecklistTemplate: checklistTemplateGrid,
  DocumentView: documentGrid,
  Form: formGrid,
  IndividualView: individualGrid,
  MemberView: memberGrid,
  RecurringTaskView: recurringTaskGrid,
  ServiceView: serviceGrid,
  SmartTaskView: smartTaskGrid,
  TaskView: taskGrid,
  TemplateView: templateGrid,
};
